<template>
  <div id="chart-line-item-item-box">
    <chart-title
        leftTitle="TQC套装门售后出错类型 left_12"
        :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
        :tooltipText="'售后统计实时数据'"
    ></chart-title>
    <date-change-card
        height="calc(100% - 30px)"
        @leftClick="leftClick"
        @rightClick="rightClick"
    >
      <div id="left_12" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { errorType } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import {formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "left_12",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      date: new Date(),
      chart: null,
      totalNum: 0,
      chartData: []
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData(){

      //初始化数据
      this.totalNum = 0;
      this.chartData = [
        { value: 0, name: "尺寸" },
        { value: 0, name: "颜色" },
        { value: 0, name: "造型" },
        { value: 0, name: "瑕疵" },
        { value: 0, name: "差缺货" },
        { value: 0, name: "变形" },
      ];

      //获取ERP 接口数据
      errorType(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        if(resp.data.套装门) {
          for (let i = 0; i < this.chartData.length; i++) {
            for (let key in resp.data.套装门) {
              if (this.chartData[i].name === key) {
                this.totalNum += resp.data.套装门[key];
                this.chartData[i].value = resp.data.套装门[key];
                break;
              }
            }
          }
        }

        this.initChart();
      });

    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_12"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        color: [
          "#1158a7",
          "#4682B4",
          "#0983ff",
          "#59abf6",
          "#abd6fc",
          "#29beb9",
          "#3bffd0",
          "#22e4ff",
          "#40E0D0",
        ],
        series: [
          {
            name: "TQC售后出错类型",
            type: "pie",
            radius: "42%",
            center: "center",
            top: "-10%",
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              formatter: "{b}：{@2012}",
              color: "#C0C4CC",
            },
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  #left_12 {
    height: 100%;
  }
}
</style>
